import React from 'react';

const ConversationBucket = {
  OPEN: 'OPEN',
  ARCHIVED: 'ARCHIVED',
};

const ConversationChannel = {
  TEXT_EMAIL: 'TEXT_EMAIL',
  INSTAGRAM: 'INSTAGRAM',
};

const initialValues = {
  isReady: false,
  conversationList: [],
  isLoadingConversations: false,
  hasMoreConversations: true,
  loadMoreConversations: () => {},
  selectedBucket: ConversationBucket.OPEN,
  setSelectedBucket: () => {},
  activeLeadId: '',
  setActiveLeadId: () => {},
  activeLeadDoc: null,
  isLoading: false,
  // Claim orchestration state
  isPendingTakeover: false,
  pendingClaimedByUsername: '',
  confirmTakeover: () => {},
  cancelTakeover: () => {},
  searchResults: null,
  handleSearch: () => {},
  selectedChannel: ConversationChannel.TEXT_EMAIL,
  setSelectedChannel: () => {},
  activeChannel: ConversationChannel.TEXT_EMAIL,
  setActiveConversation: () => {},
  igConversationList: [],
  isLoadingIGConversations: false,
  hasMoreIGConversations: true,
  loadMoreIGConversations: () => {},
  conversationPagesLoaded: 0,
  igConversationPagesLoaded: 0,
};

const LeadConversationsContext = React.createContext(initialValues);

export default LeadConversationsContext;
export {
  initialValues,
  ConversationBucket,
  ConversationChannel,
};
